const USER_FIELD_MAP = {
    $email: 'user:email',
    $phone: 'user:phone',
    $name: 'user:nickname',
}

const CRISP_USER_ID_KEY = 'crisp_user_id'

function pushCrisp(...args) {
    if (!window.$crisp) {
        return
    }

    window.$crisp.push(args)
}

function openCrispChat() {
    pushCrisp('do', 'chat:open')
}

function showHideCrispChat(hide) {
    pushCrisp('do', hide ? 'chat:hide' : 'chat:show')
}

function resetCrispSession() {
    pushCrisp('do', 'session:reset')
}

// Resets the Crisp conversation when a different user logs in, so the chat
// thread is not shared across accounts. A repeated login of the same user
// (e.g. page refresh) keeps the existing conversation.
function resetCrispSessionForUser(userId) {
    if (!userId) {
        return
    }

    const previousUserId = localStorage.getItem(CRISP_USER_ID_KEY)
    const currentUserId = String(userId)

    if (previousUserId && previousUserId !== currentUserId) {
        resetCrispSession()
    }

    localStorage.setItem(CRISP_USER_ID_KEY, currentUserId)
}

function setTrackToCrisp(event) {
    if (!event) {
        return
    }

    pushCrisp('set', 'session:event', [[[event]]])
}

function setUserDataToCrisp(userData) {
    if (!Array.isArray(userData) || !window.$crisp) {
        return
    }

    const sessionData = []

    userData.forEach(({ key, value }) => {
        if (USER_FIELD_MAP[key]) {
            pushCrisp('set', USER_FIELD_MAP[key], [value])
        } else {
            sessionData.push([key, value])
        }
    })

    if (sessionData.length) {
        pushCrisp('set', 'session:data', [sessionData])
    }
}

export {
    openCrispChat,
    showHideCrispChat,
    setTrackToCrisp,
    setUserDataToCrisp,
    resetCrispSession,
    resetCrispSessionForUser,
}
